<script lang="ts">
    import TmemItemMenu from "./TmemItemMenu.svelte";
    import { findElementMatching } from "./TmemUtils";

    function syncBtnStateWithMenu(btn: HTMLButtonElement) {
        let open = btn.dataset["open"] === "true" || false;
        const menu = (btn as any).tmemMenuItem;
        if (menu) {
            setTimeout(() => menu.$set({ open }));
        }
    }

    function initMenuItem(btn: HTMLButtonElement) {
        function onMenuItemClose() {
            btn.dataset["open"] = "false";
            syncBtnStateWithMenu(btn);
        }

        const container = document.createElement("div");
        container.classList.add("relative");
        btn.appendChild(container);
        setTimeout(() => {
            const menu = new TmemItemMenu({
                target: container,
                props: {
                    open: false,
                    onClose: onMenuItemClose,
                    exampleId: btn.dataset["translationid"],
                    authorId: btn.dataset["authorid"],
                    authorName: btn.dataset["authorname"],
                },
            });
            (btn as any).tmemMenuItem = menu;
            btn.dataset["open"] = "true";
            syncBtnStateWithMenu(btn);
        });
    }

    function handleMenuActivatorClick(btn: HTMLButtonElement) {
        let menu = (btn as any).tmemMenuItem;
        if (!menu) {
            initMenuItem(btn);
        } else {
            btn.dataset["open"] = "true";
            syncBtnStateWithMenu(btn);
        }
    }

    function handleExamplesContainerClick(event: Event) {
        // check if is a tmem__item__menu click
        let elem = event.target as HTMLElement;
        let menuActivator: HTMLButtonElement | null = findElementMatching(
            elem,
            "button.tmem__item__menu"
        ) as HTMLButtonElement;

        if (menuActivator) {
            handleMenuActivatorClick(menuActivator);
        }
    }

    const container = document.getElementById("examples");

    if (container) {
        container.addEventListener("click", handleExamplesContainerClick);
    }
</script>
